import React, { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import usePipelineQuery from '../hooks/usePipelineQuery'
import { useParameterReplacementEx } from '../../../../hooks/useAbundanceEngineParameters'
import { useVariables } from '../../../../providers/VariableProvider'

export const PipelineDataContext = createContext({ data: [], isLoading: true, isFetching: false, error: null })
const DEFAULT_VARIABLE_BINDING = {
  asOfDate: '$asOfDate',
  quickDate: '$quickDate',
  levelIds: ['$clientId'],
  levelTypeId: 201
}

export const usePipelineDataContextWithVariables = (pipeline, variableBindings) => {
  const { variables } = useVariables()
  const [_substituted, missing] = useParameterReplacementEx(variableBindings || DEFAULT_VARIABLE_BINDING, variables)

  const pd = usePipelineQuery(pipeline, _substituted, !!missing.length)
  const cd = useContext(PipelineDataContext)

  return useMemo(() => {
    return pd.enabled ? pd : cd
  }, [pd, cd])
}

function DDPDataProvider ({ pipeline, variables, children }) {
  const value = usePipelineDataContextWithVariables(pipeline, variables)

  return (
    <PipelineDataContext.Provider value={value}>
      {children}
    </PipelineDataContext.Provider>
  )
}

DDPDataProvider.propTypes = {
  /** The data pipeline to execute */
  pipeline: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  /** substitution values */
  variables: PropTypes.object,

  children: PropTypes.node
}

DDPDataProvider.defaultProps = {
}

export default DDPDataProvider
